export interface FeatureCardData {
  id: string
  videoFileName: string
  posterFileName: string
}

export const FEATURE_CARDS: FeatureCardData[] = [
  {
    id: 'image_editor',
    videoFileName: '01-image-editor.mp4',
    posterFileName: '01-image-editor.webp',
  },
  {
    id: 'video_generator',
    videoFileName: '02-video-generator.mp4',
    posterFileName: '02-video-generator.webp',
  },
  {
    id: 'nanobanana_2',
    videoFileName: '03-nano-banana.mp4',
    posterFileName: '03-nano-banana.webp',
  },
  {
    id: 'music_generator',
    videoFileName: '04-music-generator.mp4',
    posterFileName: '04-music-generator.webp',
  },
  {
    id: 'logo_generator',
    videoFileName: '05-logo-generator.mp4',
    posterFileName: '05-logo-generator.webp',
  },
  {
    id: 'seedream_2',
    videoFileName: '06-seedream.mp4',
    posterFileName: '06-seedream.webp',
  },
  {
    id: 'lyria_3',
    videoFileName: '07-lyria3.mp4',
    posterFileName: '07-lyria3.webp',
  },
]
